
import React from 'react';
import { EaseModal } from '../../../libs/EaseModal';
import { ApprovalConfigForm } from '../Forms';
import { Text1 } from '../../../styles';


const ApprovalConfigModal = (props) => {

     const renderTitle = () => {
        return (
            <div className="mb-4">
                <Text1 className="d-block" strong>
                    Approval Flow Config
                </Text1>
            </div>
        )
    };
    return (
        <EaseModal
            width={800}
            title={false}
            visible={props.visible}
            onCancel={props.toggleApprovalConfigModal}
            centered
            hideFooter
            destroyOnClose
        >
            {renderTitle()}
            <ApprovalConfigForm
                onSubmit={props.onSubmit}
                loading={props.loading}
                approvalConfig={props.approvalConfig}
            />
        </EaseModal>
    )
};

export { ApprovalConfigModal };